import yup from 'src/libraries/validator.library';

const FlightTypeShape = {
  flightType: yup.string().required(),
};

export const FlightTypeSchema = yup
  .object()
  .shape({
    flightTypeId: yup.number(),
    ...FlightTypeShape,
  })
  .defined();

export const FlightTypesListSchema = yup
  .object({
    flightType: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                flightTypeId: yup.number(),
                ...FlightTypeShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const FlightTypeFormSchema = yup
  .object()
  .shape({
    ...FlightTypeShape,
  })
  .defined();

export type IFlightType = yup.InferType<typeof FlightTypeSchema>;
export type IFlightTypesRow = yup.InferType<typeof FlightTypesListSchema>;
export type IFlightTypeForm = yup.InferType<typeof FlightTypeFormSchema>;
